module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABaUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////////////////////////////1YG+bcAAAAddFJOUwB7FC+8HesI8eBWR4LVssmqhvmLdGgEYpCWTT+bQWEHIgAAAJVJREFUGNM1j9cWwzAIQ3GGR/bqSNv7/79ZcBw9GJAlHRBR1GcEmk4KVkj72sAY8vxmqq1WjmSMY7ilNaPyzCJhvvwdhwyoPkCfmbhJ2qwJiY/VHTGHYeKhb69EcxEL7iJ8tPE5ZoEm6hatRkReWeeRlskyjzx/WUXO8mm74kOO26uyltkVP710cMuGb4u010v14pzzB6snCPejh+zwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/jiantou_icon_zpxqy.png
// module id = UuUE
// module chunks = 1